import {memo} from 'react';
import {Link} from 'react-router-dom';
import {useAppSelector, useTranslation} from '../hooks';
import {languageState} from '../redux/slices/app';

const NoMatch = () => {
  const {t} = useTranslation();
  const selectedLanguage = useAppSelector(languageState);

  return (
    <section className="min-h-screen flex align-items-center justify-content-center text-center">
      <div>
        <h2>{t('notFoundTitle')}</h2>
        <p>
          {t('notFoundText1')}{' '}
          <Link to={'/' + selectedLanguage + t('pathMenuHome')}>
            {t('notFoundText2')}
          </Link>
        </p>
      </div>
    </section>
  );
};

export default memo(NoMatch);
